<template>
    <!-- Nav (Small screens) -->
    <div class="d-md-none d-flex align-items-center justify-content-between small-nav">
        <!-- Back icon -->
        <a v-load-page="'/'" v-ripple class="navbar-brand fw-bold fs-4 py-0 m-0 rounded-circle">
            <i class="hoverable-icon bi-arrow-left"></i>
        </a>
        <!-- Menu toggler -->
        <i class="hoverable-icon bi-three-dots-vertical" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false" v-ripple></i>
        <ul class="dropdown-menu">
            <li>
                <a class="dropdown-item cursor-pointer" v-load-page="'/settings'" v-ripple>
                    <i class="me-3 bi-gear"></i>
                    Settings
                </a>
                <hr class="dropdown-divider">
                <a class="dropdown-item cursor-pointer" v-load-page="'/logout'" @click.prevent="authStore.performLogout()" v-ripple>
                    <i class="me-3 bi-box-arrow-right"></i>
                    Sign out
                    <i class="ms-auto bi-arrow-right ms-auto"></i>
                </a>
            </li>
        </ul>
    </div>
</template>

<script setup>
import { useAuthStore } from '@/stores/auth-store';

const authStore = useAuthStore();

</script>

<style lang="scss" scoped></style>